import { createFileRoute, redirect, Link } from '@tanstack/react-router';
import { AuthRequiredError, unwrap } from '@truecare/api-client';
import { api } from '../api';
import { AccountSecuritySection } from '../components/AccountSecuritySection';
import { PortalShell } from '../components/PortalShell';
import { SmsNotificationsCard } from '../components/SmsNotificationsCard';

/**
 * /security — password + 2FA for any signed-in user. Split out of /profile
 * (Phase 17 bugfixes — Option B) so the account/application page isn't overloaded
 * once document uploads moved onto it; reached from the top-right user menu.
 * Persona-agnostic: every user manages the same credentials the same way.
 */
export const Route = createFileRoute('/security')({
  beforeLoad: async () => {
    try {
      const me = await unwrap(api.GET('/api/v1/auth/me'));
      return { me };
    } catch (err) {
      if (err instanceof AuthRequiredError) {
        throw redirect({ to: '/sign-in' });
      }
      throw err;
    }
  },
  component: SecurityPage,
});

function SecurityPage() {
  const { me } = Route.useRouteContext();

  return (
    <PortalShell>
      <div className="mx-auto max-w-3xl px-6 py-10 md:py-16">
        <Link
          to="/me"
          className="inline-flex items-center gap-1.5 font-body text-sm text-ink-muted transition-colors hover:text-forest"
        >
          <span aria-hidden="true">←</span> Back to my workspace
        </Link>
        <h1 className="mt-4 font-heading text-3xl md:text-4xl text-forest">Security</h1>
        <p className="mt-2 font-body text-sm text-ink-muted">Signed in as {me.email}</p>

        <div className="mt-8 flex flex-col gap-6">
          <AccountSecuritySection />
          {/* Doc 14 (SMS-e) — renders only for SMS-capable personas (caregiver / homecare). */}
          <SmsNotificationsCard />
        </div>
      </div>
    </PortalShell>
  );
}
